export const AppDataProcessSteps = {
  ndrBanding: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you should first complete an appeal form and provide the required information. You will find details on how to do this below. If you want to appeal, you must do it within the following time limits:

        Time limits for making Appeals:

        If the Assessor has issued a Notice of a Decision in respect of a Proposal an appeal must be made to the Local Taxation Chamber within 28 days plus 48 hours (deemed notification period) of the date the Assessor sent you that Notice of Decision.

        If the Assessor has issued a Proposal Determination date in relation to a Proposal but no Notice of Decision has been provided an appeal must be made to the Local Taxation Chamber within 28 days beginning with the Proposal Determination date.

        If a Proposal Determination date in relation to a Proposal has not been issued 70 days before the last date for the Assessor to issue notice of a decision on the proposal an appeal must be made to the Local Taxation Chamber no later than 42 days before that date. The last date for the Assessor to issue notice of a decision on your proposal is based upon the date on which you made the proposal. This is the later of (i) 30 September in the year before the revaluation year which follows the valuation to which the proposal relates, (ii) 30 September in the financial year after the financial year in which the proposal is made and (iii) the last day of the period of 12 months beginning with the date on which the proposal is sent to the Assessor. For example, a proposal lodged on 1 May 2023 in connection with the 2023 revaluation, has a disposal deadline of 30 September 2025.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal if you have sent a proposal to the Assessor and:

        The Assessor has issued a Decision in response to your Proposal and the decision is either not to amend the Valuation Roll or to amend the Valuation Roll to an entry other than that detailed in your Proposal and you do not agree with the Assessor’s decision.

        The Assessor has issued a Proposal Determination Date but has not issued a Decision by the Proposal Determination Date.

        If a Proposal Determination date in relation to your Proposal has not been issued 70 days before the last date for the Assessor to issue notice of a decision on the proposal (as explained in Part 1 above).`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form A’ above and complete the ‘Notice of Appeal Form A’. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.

        Please note that Appeals should only be lodged with information that was shared with the Assessor at the Proposals stage.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Preparation for the Hearing',
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. These documents will  be either the documents sent to the Assessor in support of the Proposal or any relevant new information that has become available since the last date for the Assessor to issue a notice of a decision in relation to the Proposal.`,
      },
      {
        step: 6,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one or two ordinary members with valuation and/or rating experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the Assessor to present your cases. You will be able to ask questions and you may also be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ndrComplaint: {
    steps: [
      {
        step: 1,
        title: 'Understand what a complaint involves',
        body: `To make a complaint relating to an entry in the Valuation Roll you will first need to complete an application form (Form B) and provide the required information. You will find details on how to do this below. The last date for lodging a complaint with the Local Taxation Chamber is the later of  (i) 31st July in the year of revaluation and (ii) the last day of the period of four months beginning with the date on which the notice under section 3(2) of the Local Government (Scotland) Act 1975 was sent to the proprietor, tenant or occupier (being the date of issue of the Valuation Notice).`,
      },
      {
        step: 2,
        title: 'Types of Complaint',
        body: `
        There are four types of Complaint:

        Complaint that the yearly rent or value of any lands or heritages in the current valuation is not the correct amount (Section 13 of the Lands Valuation (Scotland) Act 1854).

        Complaint that details other than valuation are incorrect (Section 6 of the Valuation of Lands (Scotland) Amendment Act 1879).

        Complaint that particular subjects are not included in the valuation roll (Section 22 of the Local Government (Scotland) Act 1966).

        Lands and heritages consisting of a pitch for a caravan should be separately entered in the valuation roll (Section 3(1) of the Rating (Caravan Sites) Act 1976).`,
      },
      {
        step: 3,
        title: 'Complete and submit Notice of Complaint',
        body: `Before you complete the application form, please read the ‘Notes on completing Form B’ above. The completed application ‘Notice of Complaint Form B’ should be sent to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Notice of Complaint Registration ',
        body: `We will check your application form and register the Complaint if we have all the information. We aim to register Complaints within 14 days of receiving them. We will let you know when the Complaint is registered. If we cannot register the Complaint, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Attend the Hearing',
        body: `Complaints are decided by the Tribunal at the hearing. The Tribunal will comprise one legal member and one or two ordinary members with valuation and/or rating experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the Assessor to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ndrPenalty: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you’ll first need to read the guidance note above (Notes on completing Form E), complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within 28 days of the date the penalty notice was sent to you.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal the imposition of a penalty in terms of an Assessor Penalty Notice; the amount of a penalty imposed by a Local Authority Notice for failure to comply with a Local Authority Information Notice and failure to notify a change in circumstances.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form E’ above and complete the ‘Notice of Appeal Form E’. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },

      {
        step: 5,
        title: 'Preparation for the Hearing',
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. `,
      },
      {
        step: 6,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the assessor or local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ctLiability: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you’ll first need to read the guidance note (Notes on completing Form C1), complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within four months of your appeal to the Local Authority.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal if you think your council tax liability calculation is wrong and/or the incorrect discounts and/or exemptions have been applied.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form C1’ above and complete the ‘Notice of Appeal Form C1’. In the appeal form you should explain why you think the Assessor’s decision is wrong. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Preparation for the Hearing',
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. `,
      },
      {
        step: 6,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the representative from the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ctCompletion: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you’ll first need to read the guidance note (Notes on completing Form C3), complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within 21 days of the date you received the completion notice.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal if you disagree with the date on a completion notice.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form C3’ above and complete the ‘Notice of Appeal Form C3’. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Preparation for the Hearing',
        body: `If you disagree with the completion date in the Completion Notice you must provide evidence to support the date that you consider to be the correct date. You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing.`,
      },
      {
        step: 6,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the representative from the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ctBandingInValid: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you’ll first need to read the guidance note above (Notes on completing Form C-4a), complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within 28 days of the date you received the Notice stating that your appeal was invalid.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `To make an appeal you’ll first need to read the guidance note above (Notes on completing Form C-4a), complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within 28 days of the date you received the Notice stating that your appeal was invalid.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form C-4a’ above and complete the ‘Notice of Appeal Form C-4a’. In the appeal form you should explain why you think the Assessor’s decision is wrong. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Appeals are determined by the Tribunal without a hearing based on your written representations',
        body: `Appeals are decided by the Tribunal, which will consist of one legal member. The legal member will consider the parties’ written representations when making their decision. Once a decision is made, a written copy will be issued to the parties.`,
      },
    ],
  },
  ctReduction: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you’ll first need to read the guidance note (Notes on completing Form D), complete an appeal form and provide information and evidence to support your case.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal if you are aggrieved by a determination in relation to your council tax reduction application, but only after you have applied to the Local Authority for a review of their initial determination.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form D’ above and complete the ‘Notice of Appeal Form D’. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Preparation for the Hearing',
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. `,
      },
      {
        step: 6,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the representative from the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ctWater: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you’ll first need to read the guidance note (Notes on completing Form C5), complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within four months of your notice to the Local Authority that you are aggrieved by their decision.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal a decision that a dwelling is a chargeable dwelling, or that you are liable to pay Water Charges, Water Services Charges or Sewerage Charges for the dwelling or any calculation of an amount of Water Charges, Water Service Charges or Sewerage Charges you are liable to pay.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form C5’ above and complete the ‘Notice of Appeal Form C5’. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the representative from the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ctVisitorLevy: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you will first need to read the Guidance Note, complete the Notice of Appeal Form F and provide information and evidence to support your case. If you want to appeal, you must do it within 30 days of the day you received the notice of the outcome of the review from the Local Authority.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal if you disagree with a decision of the Local Authority about the operation of a visitor levy scheme, enforcement action taken by the Local Authority in relation to a visitor levy, a visitor levy penalty imposed by the Local Authority, that you are liable for a visitor levy, the amount of a visitor levy or a decision that a visitor levy return is incorrect due to a careless or deliberate miscalculation.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form F’ above and complete the ‘Notice of Appeal Form F’. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Preparation for the Hearing',
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing.`,
      },
      {
        step: 6,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member or one legal member and one ordinary member. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. During the hearing, the Tribunal will ask you and the representative from the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ctPenalty: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `To make an appeal you’ll first need to read the guidance note (Notes on completing Form C2), complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within two months of the date on which the penalty was imposed.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal if you are:

        •	aggrieved by a Penalty for failing to supply information or knowingly providing inaccurate information;
        •	aggrieved by Penalty for failing to notify the local authority;
        •	aggrieved by a Penalty for acts or omissions that resulted in an exemption or reduction you were not entitled to or you allege there is no power in the case for the Local Authority to impose the penalty.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form C2’ above and complete the ‘Notice of Appeal Form C2’. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },

      {
        step: 5,
        title: 'Preparation for the Hearing',
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. 
        `,
      },
      {
        step: 6,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the representative from the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
  ctBanding: {
    steps: [
      {
        step: 1,
        title: 'Understand what an appeal involves',
        body: `For your appeal to be a valid appeal you must have sent your Proposal to alter the council tax band to the Assessor timeously, generally this means within six months of the date you became liable to pay council tax for the Property. Please see above the link to the Scottish Assessors website for the detailed time limits. If you sent your Proposal to the Assessor outwith these time limits your Proposal will be invalid and you will have received notice from the Assessor as such. If you have received notice that your Proposal is invalid, please refer to the section of the website ‘Invalid Council Tax Banding Appeals’ below.

        To make an appeal you’ll first need to complete an appeal form and provide information and evidence to support your case. You’ll find details on how to do this below. If you want to appeal, you must do it within 32 weeks of the date the Proposal to alter the band was served on the assessor.`,
      },
      {
        step: 2,
        title: 'What can I appeal?',
        body: `You can appeal if you think your property is in the wrong council tax band or if you believe your property was incorrectly removed from or added to the council tax valuation list.`,
      },
      {
        step: 3,
        title: 'Complete and submit the appeal form',
        body: `If you want to appeal, please read the ‘Notes on completing Form C-4b’ above and complete the ‘Notice of Appeal Form C-4b’. Once completed send it to the Local Taxation Chamber. Details on how to do this are provided on the appeal form.`,
      },
      {
        step: 4,
        title: 'Appeal registration',
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`,
      },
      {
        step: 5,
        title: 'Preparation for the Hearing',
        body: `If you propose to inform the Tribunal that the valuation band of your property does not compare fairly with the bands placed on other properties then it will be advisable to tell the Assessor the properties to which you will be referring. You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. 

        The Council Tax Bands are as follows. Note the valuation date is 1st April 1991.
        
        Values not exceeding £27,000                                                                     A
        Values exceeding £27,000 but not exceeding £35,000                                               B
        Values exceeding £35,000 but not exceeding £45,000                                               C
        Values exceeding £45,000 but not exceeding £58,000                                               D
        Values exceeding £58,000 but not exceeding £80,000                                               E
        Values exceeding £80,000 but not exceeding £106,000                                              F
        Values exceeding £106,000 but not exceeding £212,000                                             G
        Values exceeding £212,000                                                                        H
        `,  
      },
      {
        step: 6,
        title: 'Attend the Hearing',
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision.

        During the hearing, the Tribunal will ask you and the assessor to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, but hearings are judicial proceedings and some formality is required.`,
      },
    ],
  },
};
